<div id="crete-tender-suppliers" class="container-fluid mt-5 has-floating-actions">
  <div class="card bg-white">
    <div class="card-header bg-white">
      <!-- Row 1: Title and Counters -->
      <div class="d-flex flex-row align-items-center mb-3">
        <h3 class="mb-0 me-3">Invite Suppliers</h3>
        <span class="badge bg-secondary me-2" title="Total Companies">{{ getUniqueCompanyCount() }} Companies</span>
        <span class="badge bg-secondary" title="Total Users">{{ getTotalUserCount() }} Users</span>
      </div>

      <!-- Row 2: Filters and Actions -->
      <div class="d-flex flex-row align-items-center">
        <div class="me-3" style="min-width: 250px;">
          <input type="text" class="form-control" placeholder="Search by name, alias, or email..."
            [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()">
        </div>
        <div class="me-3">
          <ng-select [placeholder]="'Filter by tags...'" [items]="tags" multiple="true" bindLabel="name"
            (ngModelChange)="tagChange($event)" [(ngModel)]="selectedTags">
          </ng-select>
        </div>
        <div class="ms-auto">
          <a (click)="createSupplierManually()" href="javascript:void(0)" class="btn btn-light me-2"
            data-testid="add-supplier-manually">
            <i class="me-2 fas fa-plus"></i> Add Manually
          </a>
          <a (click)="createSupplierUploadExel()" href="javascript:void(0)" class="btn btn-light me-2"
            id="locations-from-excel">
            <i class="me-2 fas fa-file-upload"></i> Upload From Excel
          </a>
          <a (click)="addSuppliersFromContacts()" href="javascript:void(0)" class="btn btn-light me-2">
            <i class="me-2 fas fa-address-book"></i> Add From Contacts
          </a>
          <a placement="left"
            [class]="'btn ' + (tenderInvitedSupplierUsers.length === 0 ? 'btn-light disabled' : 'btn-light')"
            [autoClose]="true" #deleteAllPopover="ngbPopover" [ngbPopover]="deleteAllSuppliersPopover"
            href="javascript:void(0)"
            [style.pointer-events]="tenderInvitedSupplierUsers.length === 0 ? 'none' : 'auto'">
            <i class="me-2 fas fa-trash"></i> Delete All Suppliers
          </a>
          <ng-template #deleteAllSuppliersPopover>
            <p class="mb-1 text-center">Delete all <strong>{{ tenderInvitedSupplierUsers.length }}</strong> suppliers
              from
              this tender?</p>
            <div class="d-flex gap-2">
              <button (click)="deleteAllPopover.close()" class="btn btn-sm btn-light">
                Cancel
              </button>
              <button (click)="deleteAllSuppliers(); deleteAllPopover.close()" class="btn btn-sm btn-danger">
                Delete All
              </button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table mb-0">
        <thead class="border-bottom">
          <tr>
            <th class="border-top-0">Company</th>
            <th class="border-top-0">Last Name</th>
            <th class="border-top-0">First Name</th>
            <th class="border-top-0">Email</th>
            <th class="border-top-0">Tags</th>
            <th class="border-top-0">Phone</th>
            <th class="border-top-0">Status</th>
            <th class="border-top-0"></th>
            <th class="border-top-0"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let supplier of filteredTenderInvitedSupplierUsers">
            <td [ngClass]="{'d-flex align-items-center': supplier.company.logo}">
              <div *ngIf="supplier.company.logo" class="avatar avatar-48 bg-white me-3">
                <img class="p-2" src="{{ supplier.company.logo }}" alt="{{ supplier.company.name }}">
              </div>
              {{supplier.company.name}} <span *ngIf="supplier.supplierAlias"
                class="text-muted">({{supplier.supplierAlias}})</span>
            </td>
            <td>{{supplier.firstName}}</td>
            <td>{{supplier.lastName}}</td>
            <td>{{supplier.email}}</td>
            <td>
              <span *ngFor="let tag of supplier.tags">
                <span
                  class="badge py-1 px-2 me-3 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill"
                  (click)="clickTag(tag)">{{tag['name']}}</span>
              </span>
            </td>
            <td>{{supplier.phone}}</td>
            <td>
              <i *ngIf="supplier.emailVerified" class="fas fa-user-check" placement="left"
                ngbTooltip="Active supplier on JetFuelTenders.com"></i>
              <i *ngIf="!supplier.emailVerified" class="fas fa-user-times" placement="left"
                ngbTooltip="This user hasn't yet activated their JetFuelTenders.com account"></i>
            </td>
            <td class="text-end">
              <a href="javascript:void(0)" (click)="editSupplier(supplier)">Edit</a>
            </td>
            <td class="text-end">
              <button [ngbPopover]="deleteSuuplierConfirmation" placement="left" [popoverTitle]="" [autoClose]="true"
                #p="ngbPopover" alt="Remove supplier" class="btn btn-link">
                Delete
              </button>
              <ng-template #deleteSuuplierConfirmation>
                <p class="mb-2"><strong>{{supplier.company.name}}</strong> will be removed from the from
                  this tender.</p>
                <div class="row">
                  <div class="col pe-1">
                    <button (click)="p.close()" class="btn w-100 btn-light">
                      Cancel
                    </button>
                  </div>
                  <div class="col ps-1">
                    <button (click)="deleteSupplier($event, supplier)" class="btn w-100 btn-danger">
                      Confirm
                    </button>
                  </div>
                </div>
              </ng-template>
            </td>
          </tr>
          <tr *ngIf="!filteredTenderInvitedSupplierUsers.length && !searchTerm.trim()">
            <td colspan="9">
              <p class="small text-center my-5">
                No suppliers to display
              </p>
            </td>
          </tr>
          <tr *ngIf="!filteredTenderInvitedSupplierUsers.length && searchTerm.trim()">
            <td colspan="9">
              <p class="small text-center my-5">
                No suppliers found matching "{{searchTerm}}"
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>

<jft-submission-footer data-testid="wizard-next" backLabel="Back" backIcon="bi-arrow-left" nextLabel="Continue to Review"
  nextIcon="bi-arrow-right" secondaryNextLabel="Delete Draft"
  secondaryNextClass="btn btn-link text-danger text-decoration-none fw-bold"
  [nextDisabled]="tenderInvitedSupplierUsers.length < 2"
  [validationErrors]="tenderInvitedSupplierUsers.length < 2 ? ['At least two suppliers must be invited'] : []"
  (onBack)="stepBack()" (onNext)="submitSuppliers()" (onSecondaryNext)="deleteTender()">
</jft-submission-footer>